import camelcaseKeys from 'camelcase-keys';
import fetchImpl from '../../utils/fetch';
import type { UserData } from './types';

export const getCurrentUser = async () => {
  const result: UserData = await fetchImpl<UserData>(
    '/dashboard/current-user-data',
  );

  return camelcaseKeys(result, { deep: true });
};
